import { createApp } from 'vue';

// Vue のルートを作る処理をここに集め、Vue 2 の書き方で渡された options と Vue 3 の違いをここで吸収する

const createVueApp = (options) => {
  const { router, store, propsData, data, ...component } = options;
  // Vue 3 のルートはオブジェクトの data を受け付けない
  if (data !== undefined) {
    component.data = typeof data === 'function' ? data : () => data;
  }
  const app = createApp(component, propsData);
  // DOM から取るテンプレートも SFC と同じく Vue 2 の空白の扱いにそろえる
  app.config.compilerOptions.whitespace = 'preserve';
  if (router) app.use(router);
  if (store) app.use(store);
  return app;
};

// el の中身をテンプレートにして、el の中に描画する（Vue 3 は el 自体のディレクティブを処理しない）
export const mountVueApp = (el, options) => {
  const app = createVueApp(options);
  const instance = app.mount(el);
  return { instance, unmount: () => app.unmount() };
};

// container は残して中身だけを描画結果に差し替える
export const mountVueAppInto = (container, options) => {
  const app = createVueApp(options);
  const instance = app.mount(container);
  return { instance, unmount: () => app.unmount() };
};
